module.exports = __webpack_public_path__ + "img/Mailbox.cbd7e436.svg";